// extracted by css-extract-rspack-plugin
export default {"loading":"Kn4KuLMcEJc4qA_O"};